export type PersonalInfoData = {
  firstName: string
  lastName: string
  phoneNumber: string
  birthMonth: string
  birthDay: string
  birthYear: string
  sexAssignedAtBirth: string
}

export function createEmptyPersonalInfo(): PersonalInfoData {
  return {
    firstName: '',
    lastName: '',
    phoneNumber: '',
    birthMonth: '',
    birthDay: '',
    birthYear: '',
    sexAssignedAtBirth: '',
  }
}
